function CustomPageTransition() {}

CustomPageTransition.prototype.leave = function (doneCallback) {

	let tl = new TimelineLite();
	tl.to(".page-transition-pan--second", {
		duration: 0.8,
		y: '0%',
		transformOrigin: "top",
		ease: "power3.out"
	});
	tl.to(".page-transition-pan--first", {
		duration: 0.8,
		y: '0%',
		transformOrigin: "top",
		ease: "power3.out",
		onComplete: function () {
			doneCallback();
		}
	}, "-=0.4");
};

CustomPageTransition.prototype.enter = function (doneCallback) {

	let tl = new TimelineLite();

	if( ! sessionStorage.getItem("first-load") ) {
		tl.to(".logo-first-line, .logo-second-line, .logo-glyph, .logo-point", {
			duration: 0,
			y: '50px',
			transformOrigin: "top"
		});
		tl.to(".first-page-animation-svg", {
			duration: 0,
			opacity: 1
		});
		tl.to(".logo-point", {
			duration: 0,
			stagger: 0.1,
			scale: 0,
			transformOrigin: "center"
		});
		tl.from(".logo-glyph", {
			duration: 1.5,
			stagger: 0.1,
			drawSVG: 0,
			ease: "power3.inOut"
		});
		tl.to(".logo-point", {
			duration: 0.2,
			stagger: 0.1,
			scale: 1.2,
			transformOrigin: "center"
		});
		tl.to(".logo-point", {
			duration: 0.1,
			stagger: 0.1,
			scale: 1,
			transformOrigin: "center"
		});
		tl.to(".logo-point", {
			duration: 0.1,
			stagger: 0.1,
			scale: 1.1,
			transformOrigin: "center"
		});
		tl.to(".logo-point", {
			duration: 0.1,
			stagger: 0.1,
			scale: 1,
			transformOrigin: "center"
		});
		tl.to(".logo-glyph, .logo-point", {
			duration: 1,
			y: '0px',
			transformOrigin: "top",
			ease: "power3.out"
		});
		tl.to(".logo-first-line", {
			duration: 0.8,
			y: '0px',
			transformOrigin: "top",
			ease: "power3.out"
		}, "-=0.8");
		tl.to(".logo-second-line", {
			duration: 0.8,
			y: '0px',
			transformOrigin: "top",
			ease: "power3.out"
		}, "-=0.7");
	}
	tl.to(".page-transition-pan--first", {
		duration: 0.8,
		y: '-100%',
		transformOrigin: "top",
		ease: "power3.out",
	});
	tl.to(".first-page-animation-svg", {
		duration: 0.8,
		y: '-50px',
		opacity: 0,
		transformOrigin: "top",
		ease: "power3.out",
	}, "-=0.8");
	tl.to(".page-transition-pan--second", {
		duration: 0.8,
		y: '-100%',
		transformOrigin: "top",
		ease: "power3.out",
		onComplete: function () {
			if( ! sessionStorage.getItem("first-load") ) {
				sessionStorage.setItem("first-load", "true");
			}
			doneCallback();
		}
	}, "-=0.4");

};
